import { IAddUpdateBannerRequest } from "../../../model/admin-portal/request/add-update-banner-request";
import { IAddUpdateCategoryNewsRequest } from "../../../model/admin-portal/request/add-update-category-news-request";
import { IAddUpdateGovernamentalStrucutreRequest } from "../../../model/admin-portal/request/add-update-governamental-strucutre-request";
import { IAddUpdateLinkServiceRequest } from "../../../model/admin-portal/request/add-update-link-service-request";
import { IAddUpdateNewRequest } from "../../../model/admin-portal/request/add-update-news-request";
import { ITermPaggedRequest } from "../../../model/admin-portal/request/term-pagged-request";
import { IBannersListResponse } from "../../../model/admin-portal/response/banners-list-response";
import { ICategoriesNewsListResponse } from "../../../model/admin-portal/response/categories-news-list-response";
import { IGovernamentalStructureReponse } from "../../../model/admin-portal/response/governamental-strutucture-response";
import { ILinkServicesListResponse } from "../../../model/admin-portal/response/link-services-list-response";
import { INewsListRespomse } from "../../../model/admin-portal/response/news-list-response";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";
import { serialize } from "object-to-formdata";
const defaultPath = 'Admin';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.municipalPortalUrl;


const listBanners = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IBannersListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IBannersListResponse>(), response.data));
};

const addUpdateBanner = async (params: IAddUpdateBannerRequest, file: File) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    formData.append("file", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/Banner`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
const addUpdateNews = async (params: IAddUpdateNewRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });
    if (file !== null)
        formData.append("file", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/News`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const addUpdateGovernamentalStrucuture = async (params: IAddUpdateGovernamentalStrucutreRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (file !== null)
        formData.append("image", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/GovernamentalStructure`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const addUpdateCategoryNews = async (params: IAddUpdateCategoryNewsRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/CategoryNews`
    });
};

const addUpdateServiceLinks = async (params: IAddUpdateLinkServiceRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/ServiceLink`
    });
};


const listNews = async (requst: ITermPaggedRequest): Promise<PaginationResponse<INewsListRespomse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/News`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<INewsListRespomse>(), response.data));
};

const listGovernamentalSctructure = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IGovernamentalStructureReponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IGovernamentalStructureReponse>(), response.data));
};

const listServiceLinks = async (requst: ITermPaggedRequest): Promise<PaginationResponse<ILinkServicesListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<ILinkServicesListResponse>(), response.data));
};


const listCategoryNews = async (requst: ITermPaggedRequest): Promise<PaginationResponse<ICategoriesNewsListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<ICategoriesNewsListResponse>(), response.data));
};


const getBanners = async (id: number): Promise<IBannersListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners/${id}`
    }).then((response) => Object.assign({} as IBannersListResponse, response.data));
};

const getGovernamentalStrucutre = async (id: number): Promise<IGovernamentalStructureReponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as IGovernamentalStructureReponse, response.data));
};


const getNews = async (id: number): Promise<INewsListRespomse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsListRespomse, response.data));
};


const getServiceLink = async (id: number): Promise<ILinkServicesListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks/${id}`,
    }).then((response) => Object.assign({} as ILinkServicesListResponse, response.data));
};


const getCategoryNews = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};



const deleteBanners = async (id: number): Promise<IBannersListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners/${id}`
    }).then((response) => Object.assign({} as IBannersListResponse, response.data));
};

const deleteNews = async (id: number): Promise<INewsListRespomse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsListRespomse, response.data));
};


const deleteServiceLinks = async (id: number): Promise<ILinkServicesListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks/${id}`,
    }).then((response) => Object.assign({} as ILinkServicesListResponse, response.data));
};


const deleteCategoryNews = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};

const deleteGovernamentalStructure = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};
const AdminPortalAppService = {
    deleteGovernamentalStructure, addUpdateGovernamentalStrucuture, getGovernamentalStrucutre, listGovernamentalSctructure, deleteBanners, deleteNews, deleteCategoryNews, deleteServiceLinks, listBanners, listCategoryNews, addUpdateCategoryNews, addUpdateServiceLinks, addUpdateNews, listNews, listServiceLinks, getBanners, getCategoryNews, getServiceLink, getNews, addUpdateBanner
};

export default AdminPortalAppService